import {
  convertIRateConfigurationResponseToIRateConfigurationData,
  IRateConfigurationData,
  IRateConfigurationResponse,
} from './IRateConfiguration';
import { eTransactionType } from '../eTransactionType';
import { eCoverageType } from 'ui-toolkit/enums/eCoverageType';

export interface IRateConfigSelectorResponse {
  transactionType: eTransactionType;
  formType?: eCoverageType;
  rate: IRateConfigurationResponse;
}

export interface IRateConfigSelectorData {
  transactionType: eTransactionType;
  formType?: eCoverageType;
  rate: IRateConfigurationData;
}

export const convertIRateConfigSelectorResponseToIRateConfigSelectorData = ({
  rate,
  ...rest
}: IRateConfigSelectorResponse): IRateConfigSelectorData => ({
  rate: convertIRateConfigurationResponseToIRateConfigurationData(rate),
  ...rest,
});
